import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PrinterSidebarStatus from './PrinterSidebarStatus';

/** Adds the printer control before the language selector in the existing sidebar. */
export default function PrinterSidebarPortal() {
  const [host, setHost] = useState<HTMLElement | null>(null);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const sidebar = document.querySelector<HTMLElement>('aside.sidebar');
    if (!sidebar) return undefined;

    const node = document.createElement('div');
    node.className = 'sort-center-printer-status';
    sidebar.insertBefore(node, sidebar.lastElementChild);
    setHost(node);

    const updateCollapsed = () => setCollapsed(sidebar.classList.contains('sidebar--collapsed'));
    updateCollapsed();
    const observer = new MutationObserver(() => {
      const isCollapsed = sidebar.classList.contains('sidebar--collapsed');
      if (isCollapsed) {
        node.querySelector<HTMLElement>('.appv3-sb-status__scrim[data-open="true"]')?.click();
      }
      setCollapsed(isCollapsed);
    });
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    return () => {
      observer.disconnect();
      node.remove();
    };
  }, []);

  return host
    ? createPortal(
        <div className={`appv3-sb-status ${collapsed ? 'appv3-sb-status--rail' : 'appv3-sb-status--full'}`}>
          <PrinterSidebarStatus />
        </div>,
        host,
      )
    : null;
}
